import { render, staticRenderFns } from "./ExternalImagePreview.vue?vue&type=template&id=71066a93&scoped=true&"
import script from "./ExternalImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ExternalImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalImagePreview.vue?vue&type=style&index=0&id=71066a93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71066a93",
  null
  
)

export default component.exports